import { useTranslation } from '@axo/shared/i18n';
import { Button } from '@axo/ui-core/components/Button';
import { Modal } from '@axo/ui-core/components/Modal';
import { Text } from '@axo/ui-core/components/typography';

type DuplicatedApplicationModalProps = {
  open: boolean;
  onClose: () => void;
};

export const DuplicatedApplicationModal = ({
  open,
  onClose,
}: DuplicatedApplicationModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} hasClose>
      <Modal.Header feedbackState="error">
        <Modal.Title>{t('DuplicatedApplication.title')}</Modal.Title>
        <Text
          size="s"
          dangerouslySetInnerHTML={{
            __html: t('DuplicatedApplication.description'),
          }}
        />
      </Modal.Header>

      <Modal.Actions>
        <Button size="small" variant="tertiary" onClick={onClose}>
          {t('close')}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
